<div class="inputcontainer {{ container_class }}" *ecertDisplay="action_identifier; id: id; iconY: '15px'">
  <label *ngIf="!hideLabel" [ngClass]="{ 'mt-0': !hasMargin() }">
    {{ action_identifier | promptvalue | async }}
    <span [class.visible]="verplicht" [class.hidden]="!verplicht" style="color: #ff0000">*</span>
    <br />
  </label>

  <ng-container *ngIf="disabled && inline; then gebruikTekst; else gebruikSelect"></ng-container>
  <ng-template #gebruikTekst>
    {{ getActieveOptieLabel() | promptvalue: hoofdletter | async }}
  </ng-template>
  <ng-template #gebruikSelect>
    <select
      [id]="id"
      #select
      [disabled]="disabled"
      [class.wijzigbaar]="wijzigbaar"
      [ngClass]="{ 'pr-4': !isAdresRelatieBron(), adresRelatieBron: isAdresRelatieBron() }"
      (change)="handleChange($event)"
      (focus)="focus($event)"
      (focusout)="focusOut($event)"
    >
      <option *ngIf="placeholderAlsOptieNodig()" [value]="placeholderOptieWaarde()" [disabled]="!canSelectEmptyValue">
        {{ placeholder | promptvalue | async }}
      </option>

      <option
        *ngFor="let optie of opties"
        [value]="optie[optionValueProperty]"
        [selected]="ref_object && optie[optionValueProperty] == ref_object[property]"
        [disabled]="optie.disabled || isDisabled(optie)"
      >
        {{ optie[optionLabelProperty] | promptvalue: hoofdletter | async }}
      </option>
    </select>
  </ng-template>
</div>
